<template>
	<div id="dscroll" class="m-scrollable--track m-scroller ps ps--active-y" data-scrollable="true"
		style="overflow: hidden;">
		<div class="m-portlet m-portlet--mobile">
			<PageHead label='住培生月度奖金发放报表' label2="发放比较" url="/report/achievement/stu"></PageHead>
			<div class="m-portlet__body">
				<div class="m-form m-form--label-align-right">
					<div style="float: left;margin-top: 10px;">
						<div class="m-form__group m-form__group--inline">
							<div class="m-form__label">
								<label style="width: 100px;text-align:right;">比较月：</label>
							</div>
							<div class="m-form__control">
								<el-date-picker v-model="condition.grantmonth" type="month" placeholder="比较月"
									value-format="yyyy-MM">
								</el-date-picker>
							</div>
						</div>
						<div class="d-md-none m--margin-bottom-10"></div>
					</div>
					<div style="float: left;margin-top: 10px;">
						<div class="m-form__group m-form__group--inline">
							<div class="m-form__label">
								<label style="width: 100px;text-align:right;">被比较月：</label>
							</div>
							<div class="m-form__control">
								<el-date-picker v-model="condition.comparemonth" type="month" placeholder="被比较月"
									value-format="yyyy-MM">
								</el-date-picker>
							</div>
						</div>
						<div class="d-md-none m--margin-bottom-10"></div>
					</div>
				</div>
				<div style="clear: both;"></div>
				<div class="m--margin-top-10 m--margin-bottom-10"
					style="width: 100%;text-align: center;float: initial;">
					<el-button type="primary" icon="el-icon-search" @click="Search()"
						v-loading.fullscreen.lock="fullscreenLoading" element-loading-text="正在查询中,请稍等……">查询</el-button>
				</div>
				<div class="m-portlet__body" style="padding: .2rem 2.2rem;">
					<div v-html="tableData">
					</div>
				</div>
				<!-- <div style="padding: .2rem 2.2rem;font-size: 16px;">
          {{condition.grantmonth}} 比 {{condition.comparemonth}} 多出 {{morestu}} 名学员
        </div>   -->
				<div class="m-portlet__body" style="padding: 1rem 2.2rem;">
					<el-tabs v-model="activeName" @tab-click="handleClick">
						<el-tab-pane
							:label="condition.grantmonth + ' 比 ' + condition.comparemonth + ' 多出 '+ morestu + ' 名学员 '"
							name="first">
							<div class="m-portlet__body" style="padding: 1rem 2.2rem;">
								<div v-html="tableData1">
								</div>
							</div>

						</el-tab-pane>
						<el-tab-pane
							:label="condition.grantmonth + ' 比 ' + condition.comparemonth + ' 少了 ' + lessstu + ' 名学员 '"
							name="second">
							<div class="m-portlet__body" style="padding: 1rem 2.2rem;">
								<div v-html="tableData2">
								</div>
							</div>

						</el-tab-pane>
						<el-tab-pane :label="condition.grantmonth + '\xa0'+ missstu + ' 名学员没有发钱 '" name="third">
							<div class="m-portlet__body" style="padding: 1rem 2.2rem;">
								<div v-html="tableData3">
								</div>
							</div>

						</el-tab-pane>

					</el-tabs>
				</div>

				<!-- <div class="m-portlet__body" style="padding: 1rem 2.2rem;">
          <div v-html="tableData1">
          </div>
        </div> -->
				<!-- <div style="padding: .2rem 2.2rem;font-size: 16px;">
          {{condition.grantmonth}} 比 {{condition.comparemonth}} 少了 {{lessstu}} 名学员
        </div> -->
				<!-- <div class="m-portlet__body" style="padding: 1rem 2.2rem;">
          <div v-html="tableData2">
          </div>
        </div> -->

				<!-- <div style="padding: .2rem 2.2rem;font-size: 16px;">
          {{condition.grantmonth}} {{missstu}} 名学员没有发钱
        </div>
        <div class="m-portlet__body" style="padding: 1rem 2.2rem;">
          <div v-html="tableData3">
          </div>
        </div> -->
				<div class="col-lg-12 m--align-center">
					<el-button type="success" icon="el-icon-search" @click="GotoStu()" v-if="isHasData==true">查看奖金
					</el-button>
					<el-button type="success" icon="el-icon-search" @click="BonusConfirm()" v-else v-show='IsSearch'>
						数据确认</el-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'AchievementStuCompare',
		data() {
			return {
				condition: {
					token: '',
					username: '',
					rolelevel: '',
					grantmonth: '',
					comparemonth: ''
				},
				morestu: 0,
				lessstu: 0,
				missstu: 0,
				loading1: false,
				loading2: false,
				tableData: null,
				tableData1: null,
				tableData2: null,
				tableData3: null,
				isHasData: false,
				showConfirm: '0',
				activeName: 'first',
				firstTbale: '',
				secondTbale: '',
				thirdTable: '',
				IsSearch: false,
				fullscreenLoading: false
			}
		},
		methods: {
			Search: function() {
				if (this.condition.grantmonth == null) {
					this.$message.error('比较月不能为空!')
					return
				}

				if (this.condition.comparemonth == null) {
					this.$message.error('被比较月不能为空!')
					return
				}

				var that = this
				that.fullscreenLoading = true
				
				//获取确认状态
				that.GetBonusConfirmStatus()
				//查询数据
				this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/StuCompareList', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							that.tableData = res.data.Data
							that.showConfirm = res.data.Msg
							console.log(res.data.Msg)
							that.MoreStuCount()
							that.MissStuCount()
							that.LessStuCount()

						} else {
							that.tableData = null
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						that.tableData = null
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
					})


			},
			MoreStuCount: function() {
				var that = this
				this.loading1 = true
				this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/MoreStuCount', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							var results = res.data.Data.split('|')
							that.tableData1 = results[0]
							that.morestu = results[1]
						} else {
							that.tableData1 = null
							that.morestu = 0
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						that.tableData1 = null
						that.morestu = 0
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
					})
			},
			LessStuCount: function() {
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/LessStuCount', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							var results = res.data.Data.split('|')
							that.tableData2 = results[0]
							that.lessstu = results[1]
							that.IsSearch = true
							that.fullscreenLoading = false
						} else {
							that.tableData2 = null
							that.lessstu = 0
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						that.tableData2 = null
						that.lessstu = 0
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
					})
			},
			MissStuCount: function() {
				var that = this
				this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/MissStuCount', this.condition)
					.then(res => {
						if (res.data.Code === 0) {
							var results = res.data.Data.split('|')
							that.tableData3 = results[0]
							that.missstu = results[1]
						} else {
							that.tableData3 = null
							that.missstu = 0
							that.$message({
								message: res.data.Msg + '，' + res.data.Error,
								type: 'error'
							})
						}
					})
					.catch(err => {
						that.tableData3 = null
						that.missstu = 0
						console.log(err)
						that.$message({
							message: '查询失败',
							type: 'error'
						})
					})
			},
			BonusConfirm: function() {
				//确认已经核实过人员信息
				var that = this
				if (that.showConfirm == "0") {
					that.$message({
						message: this.condition.grantmonth + ' 没有统计数据，不允许确认',
						type: 'error'
					})
					return false
				}
				var args = {
					grantmonth: that.condition.grantmonth
				}
				this.$http.post(this.$utils.Url.zpgl + '/api/APIMoneyGrant/BonusConfirm', args)
					.then(res => {
						if (res.data.Code === 0) {
							//确认过数据后，直接跳转到详细页面
							this.$router.push({
								name: 'AchievementStu',
								params: {
									assessmentmonth: that.condition.grantmonth
								}
							})
						}
					})
					.catch(err => {
						that.$message({
							message: '操作失败',
							type: 'error'
						})
					})

			},
			GotoStu: function() {
				var that = this
				this.$router.push({
					name: 'AchievementStu',
					params: {
						assessmentmonth: that.condition.grantmonth
					}
				})
			},
			GetBonusConfirmStatus: function() {
				var args = {
					token: this.condition.token,
					grantmonth: this.condition.grantmonth
				}
				var that = this
				this.$utils.HttpPost(this.$utils.Url.zpgl + '/api/APIMoneyGrant/GetBonusConfirmStatus', args, function(
					data) {
					if (data.Data == null) {
						//没有确认过学生差异数据
						that.isHasData = false
					} else {
						that.isHasData = true
					}
				}, null, null, null)
			},
			handleClick(tab, event) {
				console.log(tab, event);

			},

		},
		mounted: function() {
			this.condition.token = sessionStorage.getItem('token')
			this.condition.username = sessionStorage.getItem('username')
			this.condition.rolelevel = sessionStorage.getItem('rolelevel')

			var date = new Date()
			var year = date.getFullYear()
			var month = date.getMonth() + 1
			if(month==1){//当前月是1月，上一个月是去年12月份
				year--
				month=12
			}else{
				month--
			}
			var cyear = 0
			var cmonth = 0
			if(month==1){//前一个月是1月，上上月就是12
				cyear=year-1
				cmonth=12
			}else{
				cyear=year
				cmonth=month-1
			}
			month = month<10?'0' + month:month
			cmonth = cmonth<10?'0' + cmonth:cmonth
			
			this.condition.grantmonth = year + '-' + month
			this.condition.comparemonth = cyear + '-' + cmonth

			this.Search()

		}
	}
</script>


<style scoped="scoped">
	/deep/.el-input {
		width: 220px;
	}

	/deep/.tabTable tbody tr {
		height: 50px;
		line-height: 30px;
	}
</style>

<style scoped="scoped">
	@import '../../../assets/css/achievementinfo.css'
</style>
